export default __webpack_public_path__ + "static/media/background.6bf05510.png";